import { twMerge } from 'tailwind-merge';
import { Box, InputLabel, Typography } from '@mui/material';

import { appendInputIdToLabel } from 'utils';
import { QuestionLabel } from 'components/question-label';
import { defaultLanguage, useTranslationContext } from 'context';
import { getTranslatedQuestionLabel } from 'utils/question-label';

import { DynamicFormFields } from '.';
import { FieldArrayFieldProps } from './types';

export const FieldArrayField = ({
  label,
  inputId,
  options,
  fieldArrayProps,
}: FieldArrayFieldProps) => {
  const {
    className,
    itemClassName,
    expandableInput,
    hideControlLabels,
    inputLabelOutside,
  } = fieldArrayProps ?? {};

  const { language } = useTranslationContext();
  const isHorizontal = options?.layout === 'horizontal';
  return (
    <Box>
      {label && (
        <InputLabel component="div">
          <QuestionLabel value={appendInputIdToLabel(label, inputId)} />
        </InputLabel>
      )}
      {options && (
        <>
          <Box
            className={twMerge(
              'flex',
              !isHorizontal && 'flex-col',
              isHorizontal && 'flex-wrap',
              className
            )}
          >
            <DynamicFormFields
              fields={options.fields}
              expandableInput={expandableInput}
              inputLabelOutside={inputLabelOutside}
              hideLabels={inputLabelOutside !== false}
              container={(field, node, index) => {
                let label = getTranslatedQuestionLabel(
                  field,
                  language,
                  defaultLanguage
                );
                label = appendInputIdToLabel(label, field.inputId);
                return (
                  <Box
                    key={field.id}
                    className={twMerge(
                      'flex w-full flex-1 gap-2',
                      !isHorizontal && 'flex-col',
                      isHorizontal && 'max-w-1/2 basis-1/2',
                      index > (isHorizontal ? 1 : 0) && 'mt-2',
                      itemClassName
                    )}
                  >
                    {!hideControlLabels && !isHorizontal && (
                      <Typography component="div" className="w-full">
                        <QuestionLabel value={label} />
                      </Typography>
                    )}
                    <Box
                      className={twMerge(
                        'control',
                        isHorizontal ? 'flex-1' : 'w-full [&>div]:w-full'
                      )}
                    >
                      {node}
                    </Box>
                    {!hideControlLabels && isHorizontal && (
                      <Box className="flex-1">
                        <Typography component="div" className="mt-3">
                          <QuestionLabel value={label} />
                        </Typography>
                      </Box>
                    )}
                  </Box>
                );
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};
